<template>
  <div v-if="!loading" class="row justify-content-center mt-4" :id="fieldId">
    <template v-if="state === 'success'">
      <template v-for="field in fields" v-bind:key="field.id">
        <componentRenderer :class="`col-lg-${field.properties.grid.columns}`" :field="field" />
      </template>
    </template>
    <template v-else-if="state === 'notFound'">
      <template v-for="field in notFoundFields" v-bind:key="field.id">
        <componentRenderer :class="`col-lg-${field.properties.grid.columns}`" :field="field" />
      </template>
    </template>
    <template v-else-if="state === 'expired'">
      <template v-for="field in expiredFields" v-bind:key="field.id">
        <componentRenderer :class="`col-lg-${field.properties.grid.columns}`" :field="field" />
      </template>
    </template>
    <template v-else>
      <template v-for="field in failFields" v-bind:key="field.id">
        <componentRenderer :class="`col-lg-${field.properties.grid.columns}`" :field="field" />
      </template>
    </template>
    <div>
      <buttonComponent v-if="true" @click.native="goBack()" addClass="backButtonBraun"
        :text="$t('Back to the Braun website')" :grid="{ columns: 6 }" />
    </div>
  </div>
  <div v-else class="button mt-5 d-flex justify-content-center align-items-center">
    <div class="spinner-border spinner-border-lg mt-6" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</template>

<script>
import componentRenderer from "@/components/component-renderer";
import { mapGetters } from "vuex";
import axios from "axios";
import buttonComponent from './button-component.vue';

export default {
  name: "reclaim-bucket",
  components: { componentRenderer, buttonComponent },
  props: {
    fieldId: String,
    requires: Array,
    successAction: {
      type: Object,
      default: () => null
    },
    apiUrl: {
      type: String,
      required: true
    },
    fields: {
      type: Array,
      required: true
    },
    failFields: {
      type: Array,
      required: true
    },
    notFoundFields: {
      type: Array,
      required: true
    },
    expiredFields: {
      type: Array,
      required: true
    },
    grid: {
      type: Object
    }
  },
  data: () => {
    return {
      state: "success",
      loading: true,
      token: null,
      campaignId: null
    };
  },
  methods: {
    goBack() {
      this.goToPage("homepage", this)
    },
    sendReclaimToken() {
      return new Promise((resolve, reject) => {
        const data = {
          campaignId: this.campaignId,
          receiptToken: this.token
        };
        axios.post(this.apiUrl, data).then(r => {
          this.loading = false;
          if (r.data) {
            resolve(r.data);
          }
        });
      });
    }
  },
  mounted() {
    if (this.$route.query && this.$route.query.token && this.$route.query.campaignId) {
      this.token = this.$route.query.token;
      this.campaignId = this.$route.query.campaignId;
      this.sendReclaimToken().then(result => {
        if (result.response && !result.errorCode) {
          this.state = "success";
        } else if (!result.response && result.errorCode === 12) {
          this.state = "notFound";
        } else if (!result.response && result.errorCode === 60) {
          this.state = "expired";
        } else {
          this.state = "error";
        }
      });
    }
  }
};
</script>

<style lang="scss">
@media (min-width: 992px) {
  .wrapper {
    min-height: calc(100vh - 308px);
  }
}
</style>